import { useTranslation } from "react-i18next";

import PriceFormat from "../../utils/priceFormat";
import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** Full refund without the item coming back. */
export default function FullRefundKeepPanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  const refund = detail.estimatedRefund;
  return (
    <ActionPanelFrame
      kind="full_refund_keep"
      detail={detail}
      confirmLabel={refund ? t("Confirm refund {{amount}} – send to eBay", { amount: PriceFormat(refund.total) }) : undefined}
      onConfirm={(message) => onConfirm({ message, amount: refund?.total })}
      onCancel={onCancel}
      busy={busy}
    >
      {refund && (
        <dl className="grid grid-cols-[150px_minmax(0,1fr)] gap-x-2.5 gap-y-1.5 rounded-lg border border-gray-200 px-3 py-2.5 text-[12px]">
          <dt className="text-gray-500">{t("Refund to buyer")}</dt>
          <dd className="font-semibold text-gray-900">{PriceFormat(refund.total)}</dd>
          {refund.item !== null && refund.postage !== null && (
            <>
              <dt className="text-gray-500">{t("Made up of")}</dt>
              <dd className="text-gray-700">{t("{{item}} item + {{postage}} original postage", { item: PriceFormat(refund.item), postage: PriceFormat(refund.postage) })}</dd>
            </>
          )}
          <dt className="text-gray-500">{t("The item")}</dt>
          <dd className="text-gray-700">{t("Stays with the buyer. No label, nothing to check in.")}</dd>
        </dl>
      )}
    </ActionPanelFrame>
  );
}
